import PropTypes from 'prop-types';
import React from 'react';
import { ProjectCard } from '../common/ProjectCard.js';
import { Svg } from '../common/Svg.js';
import { projectFormatter } from '../common/projectFormatter.js';

export let ProjectCardWithFollowInfo = ({ projectIds, teacherIds, schoolIds, project, showGiveWidget }) => {
    let followMessage;
    let timePrefix = '';
    if (projectIds.includes(parseInt(project.id, 10))) {
        followMessage = <span>You followed this project</span>;
        timePrefix = 'posted ';
    } else if (teacherIds.includes(parseInt(project.teacherId, 10))) {
        followMessage = <span className="followed">
            <a className="followed" href={`${baseURL}classroom/${project.teacherId}`}><Svg icon="bookmark" />{project.teacherName}</a>
            {' '}posted a new project
        </span>;
    } else if (schoolIds.includes(parseInt(project.schoolId, 10))) {
        followMessage = <span>
            <a className="followed" href={project.schoolUrl}><Svg icon="bookmark" />{project.schoolName}</a>
            {' '}has a new project
        </span>;
    } else {
        followMessage = <span>A new project was posted</span>;
        /* global dcAnalytics userId */
        dcAnalytics.track('ProjectCardWithFollowInfo: project does not match any follow info', {
            projectId: project.id, userId, pageName,
        });
    }

    return <div>
        <div className="project-timestamp">
            {followMessage}
            <span style={{ float: 'right' }}>{timePrefix + projectFormatter.daysAgo(project.approvedTime)}</span>
        </div>
        <ProjectCard project={project} showGiveWidget={showGiveWidget} />
    </div>;
};
ProjectCardWithFollowInfo.propTypes = {
    projectIds: PropTypes.array.isRequired,
    teacherIds: PropTypes.array.isRequired,
    schoolIds: PropTypes.array.isRequired,
    project: PropTypes.object.isRequired,
    showGiveWidget: PropTypes.bool,
};
ProjectCardWithFollowInfo = React.memo(ProjectCardWithFollowInfo);
